import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { AICA_ASK_AICA_ORB_CLICKED } from '../../../utils/constants/mixpanelEvents/investorEvents';
import { Mixpanel } from '../../../utils/mixpanel';
import AskAicaOrb from '../../../common/AskAicaOrb/AskAicaOrb';
import { getCompanyPrompts } from '../../../common/AskAicaOrb/AskAicaOrb.utils';
import styles from './MobileAskAicaOrb.module.scss';

// Floating Ask AICA orb for the mobile Company Overview (RECUR-27483).
// Mirrors the desktop AskAicaV2 GlobalIcon at the mobile size/position from the
// Ask AICA mobile Figma frame (3225-63918). Tapping it opens the full-screen
// mobile Ask AICA surface (wired by Dashboard's mobile branch).
function MobileAskAicaOrb({
    onClick,
    isPageReady = true,
    companyName,
}: {
    onClick?: () => void;
    isPageReady?: boolean;
    companyName?: string;
}) {
    // Same per-PNO/role gate the desktop entry points use (AICA_DASHBOARD config):
    // hidden only when the overview tab config explicitly disables Ask AICA.
    const showAskAica = useAppSelector((state) => state.dashboard.dashboardReducer.config?.tabConfigs?.overview?.showAskAica !== false);
    const isRefreshReportOpen = useAppSelector((state) => state.investor.showRefreshReport);
    const user = useAppSelector((state) => state.user.userData);
    const params = useParams();

    if (!showAskAica || isRefreshReportOpen) return null;

    const handleClick = () => {
        Mixpanel.track(AICA_ASK_AICA_ORB_CLICKED, {
            pnoId: user?.investorOrgId,
            userId: user?.userId,
            organizationId: params.id,
        });
        onClick?.();
    };

    return (
        <button
            type="button"
            className={styles.MobileOrb}
            data-testid="mobile-askaica-orb"
            onClick={handleClick}
            aria-label="Open Ask AICA"
        >
            {/* Keyed by org id so a company switch replays the entrance. */}
            <AskAicaOrb expandOnMount ready={isPageReady} prompts={getCompanyPrompts(companyName)} playKey={params.id} key={params.id} />
        </button>
    );
}

export default MobileAskAicaOrb;
